// extracted by mini-css-extract-plugin
export default {"cls1":"ModalError-cls1_i7V","cls2":"ModalError-cls2__Iu ModalError-cls1_i7V"};